import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-axie-claim",
  "use": "icon-axie-claim-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-axie-claim\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M 8.305 11.716 C 8.06 11.579 7.763 11.583 7.522 11.727 L 4.557 13.479 L 5.718 8.93 C 7.171 9.769 8.955 9.769 10.408 8.93 L 11.585 13.544 L 8.305 11.716 Z M 8.064 1.594 C 9.809 1.597 11.224 3.02 11.226 4.78 C 11.224 6.538 9.81 7.964 8.064 7.966 C 6.316 7.965 4.901 6.538 4.898 4.78 C 4.901 3.02 6.317 1.596 8.064 1.594 Z M 13.575 14.938 L 11.748 7.784 C 12.434 6.936 12.809 5.874 12.808 4.78 C 12.808 2.143 10.68 0 8.064 0 C 5.445 0 3.317 2.143 3.317 4.78 C 3.317 5.918 3.716 6.962 4.377 7.784 L 2.55 14.938 C 2.398 15.531 2.942 16.066 3.527 15.902 C 3.594 15.883 3.658 15.856 3.717 15.822 L 7.933 13.331 L 12.426 15.835 C 12.702 15.99 13.044 15.963 13.293 15.766 C 13.543 15.572 13.654 15.246 13.575 14.939 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/axie/axie-claim.svg
// module id = lfgB
// module chunks = 62